import { DFPUnit } from '../../../components/Toolkit/DFP/DFP';
import { HOME_PAGE_DFP_CONFIG } from '../../../configs/dfpConfig';
import * as Styled from '../../../components/HomePage/styles/HomePage.styled';
import { useReducer } from 'react';
import { useOnUpdateOnly } from '../../../hooks/UseOnUpdateOnly';
import { VERTICAL } from '../../../helpers/verticals';
import { useVerticalContext } from '../../../contexts/VerticalContext';

const TopAdUnit = () => {
  const { vertical } = useVerticalContext();
  const [adUnitKey, newAdUnitKey] = useReducer((key) => key + 1, 0);
  const adUnitClass = 'common-margin-bottom';
  useOnUpdateOnly(() => {
    newAdUnitKey();
  }, [vertical]);

  const adUnits = {
    [VERTICAL.MOTOR]: (
      <DFPUnit
        key={adUnitKey}
        className={adUnitClass}
        {...HOME_PAGE_DFP_CONFIG.dd_homepage_top_motor}
      />
    ),
    [VERTICAL.MARKETPLACE]: (
      <DFPUnit
        key={adUnitKey + 1}
        className={adUnitClass}
        {...HOME_PAGE_DFP_CONFIG.dd_homepage_top_marketplace}
      />
    ),
    [VERTICAL.FARMING]: (
      <DFPUnit
        key={adUnitKey + 2}
        className={adUnitClass}
        {...HOME_PAGE_DFP_CONFIG.dd_homepage_top_farming}
      />
    ),
  };

  return (
    <Styled.HomePageUnit>
      <Styled.UnitContainer>{adUnits[vertical]}</Styled.UnitContainer>
    </Styled.HomePageUnit>
  );
};

export { TopAdUnit };
